// Split to new file to avoid issue cycle dependency between file: routes and pages/components
export const RoutePaths = {
  LOGIN: '/login',
  ROOT: '/',
  CALLBACK: '/callback',
  INIT: '/init',
  OVERVIEW: '/overview',
  MACHINE_DASHBOARD: '/machine-dashboard',
  MACHINE_DASHBOARD_DETAILS: '/machine-dashboard/:id',
  MACHINE_DASHBOARD_DETAILS_TAB: '/machine-dashboard/:id/:tab',
  ROBOT_DASHBOARD: '/robot-dashboard',
  ROBOT_DASHBOARD_DETAILS: '/robot-dashboard/:id',
  ROBOT_DASHBOARD_DETAILS_TAB: '/robot-dashboard/:id/:tab',
  MACHINES: '/devices',
  MACHINE_DETAILS: '/devices/:id',
  MACHINE_DETAILS_TAB: '/devices/:id/:tab',
  MACHINE_DETAILS_OVERVIEW: '/devices/:id/overview',
  EVENTS: '/events',
  SITES: '/sites',
  SERVICE: '/service',
  SITE_DETAILS: '/sites/:id',
  NOTIFICATIONS: '/notifications',
  USERS: '/users',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_CONDITIONS: '/terms-and-conditions',
  CONTRACT_OBLIGATION: '/contract-obligation',
  LICENSE_AGREEMENT: '/license-agreement',
  UNAUTHORIZED: '/unauthorized',
  LOGOUT: '/logout',
};
